import "core-js/stable";
import Vue from "vue";
import App from "./App";
import router from "./router";
import CoreuiVue from "@coreui/vue";
import { iconsSet as icons } from "./assets/icons/icons.js";
import store from "./store";
import VueResource from "vue-resource";
import { VueMaskDirective } from "v-mask";
import VueNumeric from "vue-numeric";
import "./global.css";
import * as XLSX from "xlsx";
import dotenv from "dotenv";
import vOutsideEvents from "vue-outside-events";
import "./plugins/bootstrap-vue.js";
import CKEditor from '@ckeditor/ckeditor5-vue2';
import VueTheMask from 'vue-the-mask'


dotenv.config();
Vue.prototype.$apiImgUrl = process.env.VUE_APP_API_IMG_URL;

Vue.prototype.$XLSX = XLSX;


Vue.directive("mask", VueMaskDirective);

Vue.use(VueResource);
Vue.config.performance = true;
Vue.use(CoreuiVue);
Vue.prototype.$log = console.log.bind(console);
Vue.use(VueNumeric);
Vue.use(vOutsideEvents);
Vue.use( CKEditor );
Vue.use(VueTheMask)

Vue.directive('currency', {
  bind(el) {
    el.oninput = function(e) {
      if (!e.isTrusted) return;

      let value = e.target.value
      let formattedValue = pars.replace(/[^\d,]/g, '').replace(/,/g, '.');eFloat(value).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      });

      e.target.value = formattedValue;
    }
  }
});

Vue.http.interceptors.push((request, next) => {
  const token = localStorage.getItem("token");

  if (token) {
    request.headers.set("Authorization", token);
    request.headers.set("Accept", "application/json");

    next();
  } else if (router.currentRoute.name !== "Login") {
    next(new Error("Not authenticated"));
    router.push({ name: "Login" });
  } else {
    next();
  }
});

new Vue({
  el: "#app",
  router,
  store,
  icons,
  template: "<App/>",
  components: {
    App,
  },
});
